import { func, object, oneOf, string } from 'prop-types'
import { Asset } from '@opallabs/cassini'
import { Size, Spacing } from '@opallabs/gem'
import {
  ButtonUploader,
  kuiperClassNames,
  LinkUploader,
} from '@opallabs/kuiper'
import {
  Button,
  ButtonIconPosition,
  ButtonSize,
  Icon,
} from '@opallabs/lapidary'
import * as styles from './styles'

const BackgroundUploader = (props) => {
  const { onUpload, onDelete, buttonText, assetReference, htmlId, theme } =
    props

  const Uploader = () => (
    <ButtonUploader
      allowableFiles={['image']}
      htmlId={htmlId}
      uploadInstructions={onUpload}
      promptText={buttonText}
      theme={theme}
    />
  )

  const Preview = () => (
    <div
      css={styles.preview({ theme })}
      className={kuiperClassNames('background-image-preview')}
    >
      <Asset
        assetReference={assetReference}
        transforms={{
          height: Spacing.XS * 15,
          width: Spacing.XS * 20,
        }}
      />
      <div
        css={styles.fileInfo({ theme })}
        className={kuiperClassNames('background-file-controls')}
      >
        <span>{assetReference.filename}</span>
        <div css={styles.actions({ theme })}>
          <LinkUploader
            allowableFiles={['image']}
            uploadInstructions={onUpload}
            promptText="Replace"
          />

          <Button
            buttonText="Remove image"
            variant="secondaryDestructive"
            hideButtonText={true}
            icon={
              <Icon
                ariaHidden={true}
                height={Size.Icon}
                glyph="gem-trash"
                width={Size.Icon}
              />
            }
            iconPosition={ButtonIconPosition.leading}
            onClick={onDelete}
            size={ButtonSize.Small}
          />
        </div>
      </div>
    </div>
  )

  const renderUploadArea = () => {
    const UploadArea = assetReference ? Preview : Uploader
    return <UploadArea {...props} />
  }

  return (
    <div className={kuiperClassNames('presentations-uploader')}>
      {renderUploadArea()}
    </div>
  )
}

BackgroundUploader.defaultProps = {
  buttonText: 'Upload',
  theme: 'light',
}

BackgroundUploader.propTypes = {
  assetReference: object,
  buttonText: string,
  htmlId: string,
  onDelete: func,
  onUpload: func,
  theme: oneOf(['dark', 'light']),
}

export default BackgroundUploader
